module.exports = __webpack_public_path__ + "img/img-3.0931e052.svg";